import React, { FC, useEffect, useState } from "react";
import { Button } from 'antd';
import { cloneDeep, isEqual , noop} from "lodash";
import { useMemberListStore } from "@stores/useMemberListStore";
import DragDrop from "@components/dragDrop/dragDrop";
import {colFilterMiddleWare , isFiltered} from '@components/filters/colFilters';
import "./tableConfig.scss";

type TTableConfigProps = {
  configUpdatehandler?: any;
  tableConfigData?: any;
  columnFilterCheck?:any;
  filteredInfo?:any;
};

const TableConfig: FC<TTableConfigProps> = ({configUpdatehandler, tableConfigData , columnFilterCheck = noop , filteredInfo ={}}: TTableConfigProps) => {
  const [selectedColumns, selectedColDataHandler] = useState<Array<{}>>([]);
  const [availableColumns, availableColDataHandler] = useState<Array<{}>>([]);
  const setIsResetLayoutEnable = useMemberListStore((state) => state.setIsResetLayoutEnable);

  useEffect(() => {
    console.log("TableConfig.useEffectI");
    let seletedCol: any = [];
    let avaialbleCol: any = [];

    if(tableConfigData && tableConfigData.length){
      for(let i=0; i< tableConfigData.length; i++) {
        if(tableConfigData[i].isSelected) {
          seletedCol.push(tableConfigData[i]);
        }
        else if(!tableConfigData[i].isSelected) {
          avaialbleCol.push(tableConfigData[i]);
        }
      }
    };

    seletedCol.sort((a: any,b: any)=> {
      return a.sequence - b.sequence;
    });
    
    selectedColDataHandler(seletedCol);
    availableColDataHandler(avaialbleCol);
  }, [tableConfigData]);

  useEffect(() => {
    console.log("TableConfig.useEffectII");

    const dafultListKey: string[] = ["priority", "patient_name"];
    const selectedListKey: string[] = [];

    tableConfigData.forEach((item: any) => {
      if (item.isDefault === "Y") {
        dafultListKey.push(item.key);
      }
     });
     
    selectedColumns.forEach((data: any) => {
      selectedListKey.push(data.key);
    });
  
    setIsResetLayoutEnable(isEqual(dafultListKey.sort(), selectedListKey.sort()));    
  },[selectedColumns, setIsResetLayoutEnable, tableConfigData])

  const getChildren = (data: any) => {
    return (
       (data && data.length) ? (
        <ul className="list-child-container">
          { data.map((child: any)=>{
              return (
                <li key={child.dataIndex} className="list-child-option"> {isFiltered({filters : filteredInfo, dataIndex : child.dataIndex}) && <span style={{color : 'red' , marginRight : '3px'}}>*</span>}{child.label}</li>
              )
            })
          }
        </ul>
    ) : null 
    );
  }

  const getSelectedColumn = (data: any) => {
    const { label,isDraggable, subColumns, children, isSelected , dataIndex} = data || {};
      return (
        <div className={`draggable-option ${isSelected ? 'selectedCol' : 'avaialbleCol'} ${!isDraggable ? 'disabled' : ''}`}>
          <div className="panelTitle-container">

            {/* {(isSelected && isDraggable )&& <span className="icon-grid dragIcon" /> } */}
            {isFiltered({filters : filteredInfo, dataIndex , subColumns}) && <span style={{color : 'red' , marginRight : '3px'}}>*</span>}
            <span className="panel-title" title={label}>{label}</span>

            {(isSelected && isDraggable) && (
                <Button type="link" className="ml-auto panel-action-btn" onClick={()=>removeOptionHandler(data)}>Remove</Button>
            )}

            {!isSelected && <Button type="link" className="clr-blueLink ml-auto panel-action-btn" onClick={()=>addOptionHandler(data)}>Add</Button>}
          </div>
          {/* function for nested children layout */}
          {getChildren(subColumns ? subColumns : children)}
        </div>
      )
  };

  const removeOptionHandler = (item: any) => {
    let copyAvailableColData = cloneDeep(availableColumns);
    let copySelectedColData = cloneDeep(selectedColumns);

    // make changes in selected option
    item.sequence = 0;
    item.isSelected = false;
    item.draggable = false;

    colFilterMiddleWare(columnFilterCheck , {config : [item] , filterInfo : filteredInfo} , () => {
      // Push into list of available to select data
      copyAvailableColData.push(item);

      // remove from selected column data
      copySelectedColData = copySelectedColData.filter((option: any) => {
        return item.dataIndex !== option.dataIndex;
      });
        copySelectedColData = updateSequence(copySelectedColData);
      copySelectedColData = sortData(copySelectedColData);
      if(copySelectedColData){
        selectedColDataHandler(copySelectedColData);
        availableColDataHandler(copyAvailableColData);
        configUpdatehandler([ ...copySelectedColData, ...copyAvailableColData]);
      } else {
        configUpdatehandler([...copyAvailableColData]);
      }
    }) 
  };

  const addOptionHandler = (item: any) => {
    let copyAvailableColData = cloneDeep(availableColumns);
    let copySelectedColData = cloneDeep(selectedColumns);

    // make changes in selected option
    item.sequence = selectedColumns.length + 1;
    item.isSelected = true;
    item.draggable = true;

    // Push into list of selected columns list
    copySelectedColData.push(item);

    // remove from avaialble column list
    copyAvailableColData = copyAvailableColData.filter((option: any) => {
      return item.dataIndex !== option.dataIndex;
    });

    copySelectedColData = updateSequence(copySelectedColData);
    copySelectedColData = sortData(copySelectedColData);

    selectedColDataHandler(copySelectedColData);
    availableColDataHandler(copyAvailableColData);
    configUpdatehandler([ ...copySelectedColData, ...copyAvailableColData]);
  };

  const sortData = (data: any) => {
    return data ? data.sort((a: any, b:any) => { return a.sequence - b.sequence }) : data;
  }

  const updateSequence = (data: any) => {
    if(data && !data.length) { return null };

    for(let i=0; i<data.length; i++){
      data[i].sequence = i+1;
    };
    
    return data;
  }

  const onDragEndHandler = (data: any) => {
    if(data && !data.length) { return null };

    data = updateSequence(data);
    data = sortData(data);

    selectedColDataHandler(data);
    configUpdatehandler([ ...data, ...availableColumns]);
  };

  return (
    <div className="TableConfigWrapper">
        <div className="selectedCol-wrapper">
            <h1 className="f16 m0 p0 clr-n125">Columns in display ({selectedColumns?.length})</h1>
            <div className="list-container" id="colDrag">
              <DragDrop 
                containerId='colDrag'
                customClass='colDragCustomClass'
                options={selectedColumns}
                reArrangeCallback={onDragEndHandler}
                customTemplate={getSelectedColumn}
              />
            </div>
        </div>
        <div className="availableCol-wrapper">
            <h1 className="f16 p0 m0 clr-n125">Available column to select ({availableColumns?.length})</h1>
            <div className="list-container">
              <DragDrop 
                containerId='colDrag'
                customClass='colDragCustomClass'
                options={availableColumns}
                reArrangeCallback={()=>{}}
                customTemplate={getSelectedColumn}
                noDrag={true}
              />         
            </div>
        </div>
    </div>
  );
};

export default TableConfig;